import { useState, useEffect } from "react";

enum ScreenSize {
    Mobile = "mobile",
    Tablet = "tablet",
    Desktop = "desktop",
}

function useScreenSize() {
  const [screenSize, setScreenSize] = useState<ScreenSize>(ScreenSize.Mobile);

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;

      if (width <= 760) {
        setScreenSize(ScreenSize.Mobile);
      } else if (width > 760 && width <= 1280) {
        setScreenSize(ScreenSize.Tablet);
      } else {
        setScreenSize(ScreenSize.Desktop);
      }
    };

    // Initial size calculation
    updateScreenSize();

    // Attach resize event listener
    window.addEventListener("resize", updateScreenSize);

    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, []);

  const isMobile = screenSize === ScreenSize.Mobile;
  const isTablet = screenSize === ScreenSize.Tablet;
  const isDesktop = screenSize === ScreenSize.Desktop;

  return { screenSize, isMobile, isTablet, isDesktop };
}

export { useScreenSize, ScreenSize };
